// import * as Styled from './styled';

import React, { JSX } from 'react';
import { Box, type BoxProps } from '@chakra-ui/react';

interface PropsInterface extends BoxProps {
	children?: React.ReactNode;
	noMarginTop?: boolean;
	mt?: number;
	mb?: number;
}

function Section(props: PropsInterface): JSX.Element {
	return (
		<Box as="section" mt={props.noMarginTop ? '0 !important' : props.mt ?? 40} mb={props.mb ?? 40} {...props}>
			{props.children}
		</Box>
	);
}

export default Section;
